import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const poolTypesAdapter = getAdapter({ idFieldName: 'value' });

const poolTypesSlice = createSlice({
  name: 'poolTypes',
  initialState: poolTypesAdapter.getInitialState(),
  reducers: {
    setPoolTypes: (state, { payload: { poolTypes } }) => {
      poolTypesAdapter.setAll(state, poolTypes);
    },
  },
});

const selectors = poolTypesAdapter.getSelectors(({ poolTypes }) => poolTypes);

export const getAllPoolTypes = (state) => selectors.selectAll(state);

export const {
  setPoolTypes,
} = poolTypesSlice.actions;

export default poolTypesSlice.reducer;
